/* eslint-disable import/prefer-default-export */
// /* eslint-disable eqeqeq */
// /* eslint-disable brace-style */
// /* eslint-disable linebreak-style */
// /* eslint-disable import/no-extraneous-dependencies */
// import attachEnterAsClick from 'utils/attachEnterAsClick';

import $ from 'jquery';
import { updateCheckboxLabels, getProcessingFee } from '../donation-payment/c-donation-payment';


export const validateDonationAmount = () => {
    const $donationForm = $('.c-stc-donation-form');
    const $donationAmountForm = $donationForm.find('.c-donation-amount');
    if ($donationAmountForm.length === 0) return true;

    const minAmount = $donationAmountForm.find('.js-donate').data('min-donate');
    const maxAmount = $donationAmountForm.find('.js-donate').data('max-donate');
    const $donateFreq = $donationAmountForm.find('.donate-hidden-freq');
    const $donateAmount = $donationAmountForm.find('.donate-hidden-amount');
    const $donateState = $donationAmountForm.find('.donate-frequency .donate-option, .donate-amounts .donate-option, .donate-amount-input input');
    const $donateAmountField = $donationAmountForm
        .find(`.js-donate .donate-option[data-amount='${$donateAmount.val()}'][data-freq-mode='${$donateFreq.val()}']`);
    const $donateAmountInput = $donationAmountForm.find('.donate-amount-input');
    const $message = $donationAmountForm.find('.donate-msg .donate-message-selected');
    const $errorCon = $donationAmountForm.find('.donate-error');
    const $buttonWraper = $donationForm.find('.submit-button-wrapper .EditingFormButtonCell');
    const $donateMonthlyFreq = $donationAmountForm.find('.donate-monthly-btn:not(.monthly-text-off)');
    const donateFreqvalue = $donateFreq.val().toLowerCase();
    const donateMonthlyFreqValue = $donationAmountForm.find('.donate-monthly-btn').length ? $donationAmountForm.find('.donate-monthly-btn').data('freq').toLowerCase() : 'no-monthly';
    const $monthlyDisclaimerMessage = $('#RecurringPaymentDisclaimer');
    const $submitButton = $buttonWraper.find('.FormButton');

    let message = '';
    let descMessage = '';
    let errorMessage = '';
    const $messageDesc = $('.js-amount-desc p');

    // clear all selection state and message/error
    $donateState.removeClass('selected');
    $message.parent().removeClass('has-msg');
    $errorCon.removeClass('has-error');

    $(`.js-donate .donate-option[data-freq='${$donateFreq.val()}']`).addClass('selected');

    if (donateFreqvalue === donateMonthlyFreqValue) {
        $donateMonthlyFreq.slideUp();
    } else {
        $donateMonthlyFreq.slideDown();
    }

    // if no freq selected, show error
    if ($donateFreq.val() === '') {
        errorMessage = $errorCon.data('error-donation-frequency-not-selected');
    }
    
    let submitBtnText;

    if (donateFreqvalue === 'recurring') {
        submitBtnText = $submitButton.data('recurring-donation-text');
        $monthlyDisclaimerMessage.removeClass('hidden');
    } else if (donateFreqvalue === 'single') {
        submitBtnText = $submitButton.data('single-donation-text');
        $monthlyDisclaimerMessage.addClass('hidden');
    }

    $submitButton.attr('value', submitBtnText.replace('[amount]', `$${$donateAmount.val()}`));

    // amount
    if ($donateAmount.val() === '') {
        errorMessage = $errorCon.data('error-amount-missing');
    } else if ($donateAmountField.length > 0) { // if there is donate option that match with donate amount hidden value
        $donateAmountField.addClass('selected');
        message = $donateAmountField.data('message');
        descMessage = message;
    } else { // if user use custom amount then validation goes here
        if ($donateAmount.val() !== '') {
            $donationAmountForm.find('.donate-amount-input input').addClass('selected');
        }

        if (minAmount <= $donateAmount.val() && maxAmount >= $donateAmount.val()) {
            message = '';
            descMessage = $donateAmountInput.data('message');
        } else {
            if ($donateAmount.val() > maxAmount) {
                if (errorMessage !== '') errorMessage += '<br />';
                errorMessage += ($errorCon.data('error-max-amount') + maxAmount);
            }

            if ($donateAmount.val() < minAmount) {
                if (errorMessage !== '') errorMessage += '<br />';
                errorMessage += ($errorCon.data('error-min-amount') + minAmount);
            }
        }
    }

    // emptying message
    $message.html('');
    $messageDesc.html('');

    // render message
    if (message !== '') {
        $message.html(`$${$donateAmount.val()} ${message}`).parent().addClass('has-msg');
    }

    // render descMessage
    if (descMessage !== '') {
        const donationType = $donationAmountForm.find('.js-donate').data(`donation-${$donateFreq.val().toLowerCase()}`);
        $messageDesc.html(`Your ${donationType} of <strong>$${$donateAmount.val()}</strong> ${descMessage}`);
    }

    // render errorMessage
    if (errorMessage !== '') $errorCon.addClass('has-error').html(errorMessage);

    // return true or show error
    if (errorMessage === '') return true;

    return false;
};

// donation amount bind
// update payment form message - donate amount
export const initDonationAmountUpdateAction = currentPaymentData => {
    const $donationForm = $('.c-stc-donation-form');
    const $donationAmountForm = $donationForm.find('.c-donation-amount');
    const $donateOptions = $donationAmountForm.find('.donate-frequency .donate-option, .donate-amounts .donate-option, .donate-monthly-btn');
    const $donateCustom = $donationAmountForm.find('.donate-amount-input input');
    const $donateFreq = $donationAmountForm.find('.donate-hidden-freq');
    const $donateAmount = $donationAmountForm.find('.donate-hidden-amount');
    const $errorCon = $donationAmountForm.find('.donate-error');
    const $amoutOptions = $donationAmountForm.find('.donate-amounts .donate-option');
    const $preSelectedOptions = $donationAmountForm.find('.donate-amounts .donate-option.selected');
    const $message = $donationAmountForm.find('.donate-msg .donate-message-selected');
    const $iconHolder = $donationAmountForm.find('.donation-icon');
    const $recurringFields = $('#recurring-form');
    const $amountDesc = $donationAmountForm.find('.payment-details .js-amount-desc strong span');

    if ($donationAmountForm.length <= 0) return;

    // check if there is initial value has been set.
    if ($preSelectedOptions.length) {
        $donateAmount.val($preSelectedOptions.data('amount')).trigger('change');
        $donateCustom.val('');
        // update processing fee API call
        currentPaymentData.currentDonationAmount = $donateAmount.val();
        getProcessingFee(currentPaymentData);
    }

    // on donation freq change, show hide message/error, update processing fee API call
    $donateFreq.change(() => {
        const $option = $('.js-card-form-select select');
        validateDonationAmount();
        currentPaymentData.currentPaymentType = $option.find(':selected').data('form-id');
        currentPaymentData.currentDonationAmount = $donateAmount.val();
        getProcessingFee(currentPaymentData);
    }).change();

    // on donation amount change, show hide message/error, remove session storage, update processing fee API call
    $donateAmount.change(() => {
        validateDonationAmount();
        currentPaymentData.currentDonationAmount = $donateAmount.val();
        getProcessingFee(currentPaymentData);
    }).change();


    // on selection change, update donation
    $donateOptions.click(function (e) {
        e.preventDefault();
        const $el = $(this);

        if ($el.data('freq') !== undefined) {
            $donateFreq.val($el.data('freq')).trigger('change');
            // Show hide the donation amount options for the frequency selected
            $('.donate-amounts .donate-option').hide();
            $(`.donate-amounts .donate-option[data-freq-mode='${$el.data('freq')}']`).show();
            if (!$donateCustom.val()) {
                const lastFreqAmount = $donateFreq.data(`last-${$donateFreq.val().toLowerCase()}-amount`);
                // No custom donation value, then we set the 2nd donation amount options as selected by default
                if (lastFreqAmount) {
                    $(`.donate-amounts .donate-option[data-freq-mode='${$el.data('freq')}']`).filter(`[data-amount="${lastFreqAmount}"]`).click();
                } else {
                    // No last stored frequency amount, so click the 2nd amount by default
                    $(`.donate-amounts .donate-option[data-freq-mode='${$el.data('freq')}']`).eq(1).click();
                }
            }

            if ($recurringFields.length) {
                $recurringFields.addClass('not-needed');

                if (window.donationTypes && $el.data('freq') === window.donationTypes.Recurring) {
                    $recurringFields.removeClass('not-needed');
                }
            }
        }

        if ($el.data('amount') !== undefined) {
            $donateFreq.data(`last-${$donateFreq.val().toLowerCase()}-amount`, $el.data('amount'));
            $donateAmount.val($el.data('amount')).trigger('change');
            $donateCustom.val('');

            // On amount selection, we also change the displaying icon
            if ($iconHolder.length && $el.find('.amount-icon').length) {
                $iconHolder.html($el.find('.amount-icon').html());
            }
        }

        // update ammount on payment form
        if ($amountDesc.length > 0) {
            $amountDesc.text($el.data('amount'));
        }

        updateCheckboxLabels($el.data('freq'));
    });

    // on keyup in custom donation, update donation
    $donateCustom.keyup(function () {
        $donateAmount.val($(this).val());

        // trigger change if error visible
        if ($errorCon.hasClass('has-error')) $donateAmount.trigger('change');

        // Check if we have a valid value in the input, if so, unselect the other options
        if ($(this).val()) {
            $amoutOptions.removeClass('selected');
            $message.html('').parent().removeClass('has-msg');
        }
    });

    // on keyup in custom donation, update donation
    $donateCustom.change(function () {
        $donateAmount.val($(this).val()).trigger('change');
    });
};

export const initIcon = () => {
    const $donationIcon = $('.donation-icon');

    if (!$donationIcon.length) { return; }

    const $selectedDonation = $('.donate-option.selected');

    const selectedIcon = $selectedDonation.find('.amount-icon').html();
    const $clonedImage = $(selectedIcon).clone();

    $donationIcon.html('').append($clonedImage);
};

// init active state donation amount on load.
export const initDonationAmount = () => {
    const $donateFreq = $('.donate-hidden-freq');
    const $donateAmount = $('.donate-hidden-amount');
    const $lastDonateAmount = $donateFreq.data(`last-${$donateFreq.val().toLowerCase()}-amount`);

    const donateValue = $lastDonateAmount ? $lastDonateAmount : $donateAmount.val();

    const $donateAmountField = $(`.donate-option[data-amount='${donateValue}']`);

    // window.globalHelper.orderSessionManager.init();
    window.globalHelper.orderSessionManager.setAppealDonationValues();

    $(`.donate-option[data-freq='${$donateFreq.val()}']`).addClass('selected');
    $('.donate-amounts .donate-option').hide();
    $(`.donate-amounts .donate-option[data-freq-mode='${$donateFreq.val()}']`).show();

    if ($donateAmountField.length > 0) {
        $donateAmountField.addClass('selected');
    } else {
        $('.donate-amount-input input').val(donateValue).addClass('selected');
    }
};



// WEBPACK FOOTER //
// ./src/components/donation-amount/c-donation-amount.js